import IdeaAreaStats from './IdeaAreaStats';
import PopularRegionStats from './PopularRegionStats';
import PopularTopicsStats from './PopularTopicsStats';
import TopIdeasByExpertStats from './TopIdeasByExpertStats';
// import TopIdeasByLikesStats from './TopIdeasByLikesStats';
import TotalIdeaStats from './TotalIdeaStats';

function IdeasGraphs() {
  return (
    <div className="grid md:grid-cols-2 gap-6">
      <TotalIdeaStats />
      {/* <PopularTypeStats /> */}
      <IdeaAreaStats />
      <PopularRegionStats />
      <PopularTopicsStats />
      {/* <TopIdeasByLikesStats className="col-span-2" /> */}
      <TopIdeasByExpertStats className="col-span-2" />
    </div>
  );
}

export default IdeasGraphs;
